// CREATE_COMPANY_PUBLIC
import {ICreatePublicCompany} from "../../../types/company.interface";
import customAxios from "../../customAxios";

import {CREATE_COMPANY_PUBLIC} from "../../routes";

const createCompanyPublic = async (formData: ICreatePublicCompany) => {
  try {
    return (
      await customAxios.post(CREATE_COMPANY_PUBLIC, {
        ...formData,
        province: formData.province._id,
        city: formData.city._id,
      })
    ).data;
  } catch (error: unknown) {
    console.error({CREATE_COMPANY_PUBLIC: error});
    return false;
  }
};

export default createCompanyPublic;
